import { useId } from 'react-id-generator';
import BeeCheckboxTriState from './BeeCheckboxTriState';
import BeeErrorLabel from './BeeErrorLabel';
import BeeInfoLabel from './BeeInfoLabel';

import './BeeValidatedCheckboxTriState.scss';

type BeeValidatedCheckboxTriStateProps = {
  label?: string;
  stateNull?: string;
  stateFalse?: string;
  stateTrue?: string;
  errorLabel?: string | null;
  neutralLabel?: string | null;
  validLabel?: string | null;
  value?: boolean | undefined | null;
  disabled?: boolean;
  formstate?: string;
  readOnly?: boolean;
  required?: boolean;
  onChange?: (e: any) => void;
};
export function BeeValidatedCheckboxTriState({
  label,
  stateNull,
  stateFalse,
  stateTrue,
  errorLabel,
  neutralLabel,
  validLabel,
  value,
  disabled,
  formstate,
  required,
  readOnly,
  onChange
}: BeeValidatedCheckboxTriStateProps) {
  const currentId = useId(1, 'bee-val-tri-checkbox-')[0];

  //classNames
  const labelClassNames = 'bee-validated-tri-state-checkbox';

  const textSize = 'medium';
  const inputFormstate = formstate === 'none' ? 'neutral' : formstate;

  function change(e: any) {
    if (!disabled && onChange) {
      onChange(e);
    }
  }

  const renderLabel = () => {
    return (
      <div className={labelClassNames}>
        {formstate === 'error' && errorLabel ? (
          <BeeErrorLabel size={textSize} label={errorLabel} visible={true} />
        ) : formstate === 'valid' && validLabel ? (
          <BeeInfoLabel
            size={textSize}
            label={validLabel}
            type={'valid'}
            visible={true}
          />
        ) : formstate === 'neutral' && neutralLabel ? (
          <BeeInfoLabel
            size={textSize}
            label={neutralLabel}
            type={'neutral'}
            visible={true}
          />
        ) : null}
      </div>
    );
  };
  return (
    <div id={currentId}>
      <BeeCheckboxTriState
        label={label}
        stateNull={stateNull}
        stateFalse={stateFalse}
        stateTrue={stateTrue}
        value={value}
        disabled={disabled}
        formstate={inputFormstate}
        required={required}
        readOnly={readOnly}
        onChange={(e) => change(e)}
      />
      {formstate !== 'none' && (errorLabel || neutralLabel || validLabel)
        ? renderLabel()
        : null}
    </div>
  );
}

export default BeeValidatedCheckboxTriState;
